<template>
    <div class="reveal" id="incomingCall" data-close-on-click="false" data-reveal="" >
        <h1>Incoming Call</h1>
        <hr>
        <div class="text-center incoming">
        <h2>You have an incoming call from </h2>
        <h3 class="large">{{ callScreenDetails }}</h3>
        <hr class="invisible">
        <ul class="menu align-center">
            <li><a @click="updateIncommingCallStatus(true)" class="animate__animated animate__bounce animate__infinite animate__delay-1s" href="#/"><img src="@/assets/images/icons/call-screen/icon-calls-start.svg" alt="answer"></a></li>
            <li><a class="grow" href="#/" @click="updateIncommingCallStatus(false)"><img src="@/assets/images/icons/call-screen/icon-calls-end.svg" data-close=""   alt="reject"></a></li>
        </ul>
        <hr class="invisible">
        </div>
        <button class="close-button" data-close="" aria-label="Close modal" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
            <path d="M10 0a10 10 0 00-7.07 17.071c3.905 3.905 10.236 3.905 14.141 0 3.905-3.905 3.906-10.236 0-14.14A9.94 9.94 0 0010.002 0zm5.934 15.934c-3.27 3.27-8.592 3.27-11.866 0a8.39 8.39 0 1111.866 0z" fill="#161938" fill-rule="nonzero"></path>
            <path d="M13.91 6.07a.802.802 0 00-1.138 0L9.987 8.856l-2.94-2.942a.803.803 0 10-1.138 1.138L8.85 9.99l-2.941 2.942a.805.805 0 001.138 1.141l2.945-2.944 2.784 2.783a.816.816 0 001.138.004l.004-.004a.802.802 0 000-1.137l-2.784-2.784L13.926 7.2a.813.813 0 00-.016-1.13z" fill="#161938" fill-rule="nonzero"></path>
        </svg>
        </button>
    </div>
</template>
<script>
import { blacktel } from '../../../config/pluginInit'
export default {
    name: 'incoming-call',
    props: {
        callScreenDetails : {
            from: '0000000000' 
        }
    },
    data () {
        return {
        }
    },
    mounted () {
        $(document).foundation();
        blacktel.foundationInit()
    //    let model = new Foundation.Reveal($('#incomingCall') ;
    },
    methods: {
        updateIncommingCallStatus (status) {
            this.$emit('updateIncommingCallStatus', status)
        },
        getName (number) {
            if(number == undefined || number == '') return '';
            // get name from address book contact
            let result = blacktel.searchAddressBookName(number)
            let result1 = blacktel.searchvirtualNumbersName(number)
            if(result != number){
                return result
            }else if (result1 != number){
                return result1
            }else {
                if(number.includes("+")) {
                    return number
                } else {
                    return '+' + number
                }
            }
        },
    }
}
</script>
